import {
  ISmartMeterColumn,
  SmartMeterColumnValues,
} from "./smartMeterColumn.types"

export class SmartMeterColumn implements ISmartMeterColumn {
  constructor({
    errorCode,
    errorStatus,
    lastOrchestration,
    orchestrationStatus,
    serviceRequest,
    latestAlert,
    latestAlertStatus,
    firmwareStatus,
    firmwareVersion,
    gbcsVersion,
    manufacturer,
    model,
    paymentMode,
    region,
    smetsVersion,
    variant,
  }: {
    errorCode: SmartMeterColumnValues
    errorStatus: SmartMeterColumnValues
    lastOrchestration: SmartMeterColumnValues
    orchestrationStatus: SmartMeterColumnValues
    serviceRequest: SmartMeterColumnValues
    latestAlert: SmartMeterColumnValues
    latestAlertStatus: SmartMeterColumnValues
    firmwareStatus: SmartMeterColumnValues
    firmwareVersion: SmartMeterColumnValues
    gbcsVersion: SmartMeterColumnValues
    manufacturer: SmartMeterColumnValues
    model: SmartMeterColumnValues
    paymentMode: SmartMeterColumnValues
    region: SmartMeterColumnValues
    smetsVersion: SmartMeterColumnValues
    variant: SmartMeterColumnValues
  }) {
    this.errorCode = errorCode
    this.errorStatus = errorStatus
    this.lastOrchestration = lastOrchestration
    this.orchestrationStatus = orchestrationStatus
    this.serviceRequest = serviceRequest
    this.latestAlert = latestAlert
    this.latestAlertStatus = latestAlertStatus
    this.firmwareStatus = firmwareStatus
    this.firmwareVersion = firmwareVersion
    this.gbcsVersion = gbcsVersion
    this.manufacturer = manufacturer
    this.model = model
    this.paymentMode = paymentMode
    this.region = region
    this.smetsVersion = smetsVersion
    this.variant = variant
  }
  [key: string]: { [key: string]: string }
}
